import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { GRID_DEBOUNCED_SEARCH_DELAY } from "../../constants/global";

export const SearchToolbar = () => {
  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }} >
      <GridToolbarQuickFilter 
        debounceMs={GRID_DEBOUNCED_SEARCH_DELAY} 
      
      />
    </GridToolbarContainer>
  );
}